import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { DataTable } from "@/components/DataTable";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";

export default function FacultyPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name:"", subject:"", experience_years:1, salary:30000, qualification:"MSc", email:"", phone:"" });

  const load = async () => setItems((await api.get("/faculty")).data);
  useEffect(()=>{load()},[]);

  const create = async (e) => {
    e.preventDefault();
    await api.post("/faculty", { ...form, experience_years:Number(form.experience_years), salary:Number(form.salary), status:"active", joining_date: new Date().toISOString().slice(0,10)});
    setOpen(false); toast.success("Faculty added"); load();
  };

  return (
    <div>
      <PageHeader
        title="Faculty"
        subtitle={`${items.length} teachers on staff`}
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><button className="btn-primary" data-testid="add-faculty-btn">+ Add faculty</button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Add faculty</DialogTitle></DialogHeader>
              <form onSubmit={create} className="space-y-3">
                <input required placeholder="Full name" data-testid="faculty-name-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.name} onChange={e=>setForm({...form, name:e.target.value})}/>
                <div className="grid grid-cols-2 gap-2">
                  <input required placeholder="Subject" data-testid="faculty-subject-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.subject} onChange={e=>setForm({...form, subject:e.target.value})}/>
                  <input placeholder="Qualification" data-testid="faculty-qualification-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.qualification} onChange={e=>setForm({...form, qualification:e.target.value})}/>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <input type="number" placeholder="Experience (years)" data-testid="faculty-exp-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.experience_years} onChange={e=>setForm({...form, experience_years:e.target.value})}/>
                  <input type="number" placeholder="Salary" data-testid="faculty-salary-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.salary} onChange={e=>setForm({...form, salary:e.target.value})}/>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <input placeholder="Email" data-testid="faculty-email-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.email} onChange={e=>setForm({...form, email:e.target.value})}/>
                  <input placeholder="Phone" data-testid="faculty-phone-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})}/>
                </div>
                <DialogFooter><button className="btn-primary" data-testid="faculty-save-btn">Save</button></DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
        }
      />
      <DataTable
        testid="faculty-table"
        columns={[
          { key:"name", label:"Name", render: r => (
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-[#EAF3FB] text-[#0A66C2] flex items-center justify-center text-xs font-semibold">{r.name?.[0]}</div>
              <div>
                <div className="font-semibold">{r.name}</div>
                <div className="text-xs text-[#00000099]">{r.qualification}</div>
              </div>
            </div>
          )},
          { key:"subject", label:"Subject" },
          { key:"experience_years", label:"Exp (yrs)" },
          { key:"salary", label:"Salary", render: r => `₹${(r.salary||0).toLocaleString('en-IN')}` },
          { key:"phone", label:"Phone" },
        ]}
        rows={items}
      />
    </div>
  );
}
